import arsenalLogo from '$lib/assets/clubs/Arsenal.svg';
import arsenalTestimonialBg from '$lib/assets/arsenal-testimonial-bg.webp';

export const testimonialMockData = {
	testimonials: [
		{
			id: '1',
			quote:
				"It's great to work so closely with Planet League to inspire our supporters to drive even more positive action across our local and global communities.",
			authorName: 'Juliet Slot',
			authorRole: 'Chief Commercial Officer',
			organizationName: 'Arsenal FC',
			organizationLogoUrl: arsenalLogo,
			backgroundImageUrl: arsenalTestimonialBg
		}
		// {
		// 	id: '2',
		// 	quote:
		// 		'Planet League has transformed how our fans engage with sustainability. The impact has been tremendous.',
		// 	authorName: 'John Smith',
		// 	authorRole: 'Sustainability Director',
		// 	organizationName: 'Manchester United',
		// 	organizationLogoUrl: 'https://picsum.photos/seed/team-manutd/200',
		// 	backgroundImageUrl: 'https://picsum.photos/seed/stadium2/1920/1080'
		// }
	]
};
